var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/normal-question-edit.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-0d720e6d!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/normal-question-edit.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/NormalQuestionEdit.vue
// module id = 657
// module chunks = 1